var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{model:{value:(_vm.paymentTypeCode),callback:function ($$v) {_vm.paymentTypeCode=$$v},expression:"paymentTypeCode"}},_vm._l((_vm.paymentTypeList),function(item){return _c('el-radio',{key:_vm.index,attrs:{"label":item.dictCode}},[_vm._v(_vm._s(item.dictName))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }